import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
		isProxy: false,  // 是否本地解决跨域
        userInfo: null,
		BASE_URL: process.env.VUE_APP_ITEM == 'vct' ? process.env.VUE_APP_BASE_URL : '',
		itemName: process.env.VUE_APP_ITEM == 'vct' ? '外文投稿期刊选择' : '项目名',
		itemSid: process.env.VUE_APP_ITEM == 'vct' ? process.env.VUE_APP_SID : '',
    },
    getters: {
		// store.getters.getBASE_URL
		getBASE_URL: state => {
			var BASE_URL = ''
			if(process.env.VUE_APP_ITEM == 'vct') {
				if(process.env.NODE_ENV === "development" && state.isProxy) {
					BASE_URL = '/api'
				} else {
					BASE_URL = process.env.VUE_APP_BASE_URL
				}
			}
			return BASE_URL
		}
	},
    mutations: {
        setUserInfo (state, data) {
            state.userInfo = data
        },
    },
    actions: {},
    modules: {}
})